import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Correct from "../../img/correct.jpg";
import { checkFirstName } from "../../utils/validations";
import { useSelector } from "react-redux";
import InfoPromp from "../comp/InfoPromp";
import CardInfo from "../../img/cardFname_info.png";

function FirstName({ form, setForm, credircard, placeholder, setFocusOnInput = () => {} }) {
  const { t } = useTranslation();
  const [tradeInfo] = useSelector((state) => [state.tradeInfo]);
  useEffect(() => {
    if (!form.firstName.checked && !credircard) {
      let name = tradeInfo?.user?.username ? tradeInfo?.user?.username : localStorage?.getItem("__frm_name");
      if (name) {
        const nameArr = String(name).split(" ");
        nameArr.length > 1 && nameArr.pop();
        name = nameArr.join(" ").trim();
        setForm((prev) => {
          return {
            ...prev,
            firstName: { ...prev.firstName, value: name },
          };
        });
        checkFirstName({ form: form, setForm: setForm, data: name });
      }
    }
  }, []);
  return (
    <>
      <TextField
        onFocus={() => {
          setFocusOnInput(true);
        }}
        onClick={(event) => {
          event.stopPropagation();
        }}
        placeholder={placeholder || ""}
        inputProps={{ autocomplete: "new-password", "ga-data": "337" }}
        size="small"
        error={!form.firstName.valid}
        helperText={!form.firstName.valid && t("invalid_name")}
        className="homeMobile__filling__content__input"
        label={t("first_name")}
        variant="outlined"
        value={form.firstName.value}
        onChange={(event) => {
          var format = /[0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`·～！¥（）—】【」「、｜；：’‘“”？》。《，]+/g;
          if (credircard) {
            format = /[^a-zA-z ]/g;
          }
          var value = event.target.value;
          value = value.replace(format, "");
          if (value?.length > form.firstName.max) {
            value = value.slice(0, form.firstName.max);
          }
          setForm((prev) => {
            return {
              ...prev,
              firstName: { ...prev.firstName, value: value },
            };
          });
        }}
        onBlur={() => {
          checkFirstName({ form: form, setForm: setForm });
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <img
                src={Correct}
                alt=""
                style={{
                  display: form.firstName.valid && form.firstName.checked ? "block" : "none",
                }}
              />
              {credircard && <InfoPromp promp={<img src={CardInfo} alt="" />} />}
            </InputAdornment>
          ),
        }}
      />
    </>
  );
}

export default FirstName;
